import { DELETE_INFO_CARDS_START } from '../../types';

export const delete_info_cards = (payload) => ({
  type: DELETE_INFO_CARDS_START,
  payload,
});
